<template>
    <svg width="96" height="96" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd" stroke="currentColor">
            <!-- @vue-ignore -->
            <circle stroke-width="2" cx="48" cy="48" r="39" />
            <!-- @vue-ignore -->
            <path
                d="M43.043 23c5.85 1.032 8.174 5.09 9.372 9.065l.168.58.153.578.14.572.13.564.176.828.46 2.276.15.665.102.412c.035.133.07.26.107.384l.115.353c.294.842.665 1.38 1.23 1.46 1.549 0 2.168-1.648 2.42-3.656l.056-.51.043-.519.016-.262.036-.79.014-.525.012-.772.005-.74.307.153.322.17.334.187.347.206.356.224.182.12.37.255.375.276c.127.096.254.195.382.298l.385.321c.193.167.387.342.581.527l.389.381c.194.197.387.404.58.621l.383.447C65.778 40.223 68 45.145 68 53c0 11.046-8.954 20-20 20s-20-8.954-20-20c0-6.225 3.178-11.342 6.414-15.383l.588-.722.705-.848 1.532-1.763.45-.529.703-.85.477-.602.479-.627c1.907-2.555 3.695-5.662 3.695-8.676z"
                stroke-width="2"
            />
        </g>
    </svg>
</template>
